export class MenuCategoryPair {
    id: number;
    label: string;
}

export class AdditionalCategories {
    public static UNCATEGORIZED = {id: -1, label: 'Uncategorized'} as MenuCategoryPair;
    public static MEMBERSHIPS = {id: -100, label: 'Memberships'} as MenuCategoryPair;
    public static GIFT_CARDS = {id: -101, label: 'Gift Cards'} as MenuCategoryPair;
}
